import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ROUTES } from 'src/config/routeConfig';
import ErrorBoundary from 'src/components/commonComponents/errorBoundary/errorBoundary';
import NavigationMetrics from 'src/utils/katalMetrics/pageMetrics';

import SNOWHome from 'src/pages/home/SNOWHome';
import FindEntity from 'src/pages/findEntity/FindEntity';
import FindCycle from 'src/pages/findEntity/FindCycle';
import Dashboard from 'src/pages/dashboard/Dashboard';
import Contact from 'src/pages/contact/contact';
import EntitySearch from 'src/pages/entitySearch/entitySearch';
import ManageWorkflowData from 'src/components/ManageWorkflows/ManageWorkflowTable';
import ExecuteWorkflowTable from 'src/components/ExecuteWorkflows/ExecuteWorkflowTable';
import CreateSelfServeWorkflow from 'src/pages/CreateSelfServeWorkflow/CreateSelfServeWorkflow';
import ViewWorkflow from 'src/pages/ViewWorkflow/ViewWorkflow';
import RequirementsPage from 'src/components/selfServeWorkflows/requirementsPortal/RequirementsPortal';
import BulkExecutionRequirementPortal from 'src/components/selfServeWorkflows/requirementsPortal/BulkExecutionRequirementPortal';
import ApplicationOperationNavigation from 'src/components/ApplicationOperationManagement/ApplicationOperationNavigation';
import { AttributeManagementNavigation } from 'src/config/Lazy';
import WhatsNewPage from 'src/pages/WhatsNew/WhatsNewPage';
import SupportedTaskTypes from 'src/pages/SupportedTaskTypes/SupportedTaskTypes';
import NotFound from 'src/pages/notFound/NotFound';
import TaskDashboard from 'src/pages/taskDashboard/TaskDashboard';
import UpdateWFDefinitionStep from 'src/components/createWorklow/updateWFDefinitionStep/updateWFDefinitionStep';
import DndFlow from 'src/pages/reactflow/workflowCreationCanvas';
import SelfServeWorkflowDetails from 'src/pages/reactflow/requirementsPage';
import TaskOnboarding from 'src/pages/reactflow/taskOnboarding';
import { FullPageChat } from 'src/components/commonComponents/ChatbotWidget';
import LayoutEditorPage from 'src/pages/LayoutEditor/LayoutEditorPage';

import {
	PreLaunchWorkflow,
	CreateP2RRequest,
	RADInitialPage,
	ReselienceInitialPage,
	DockmasterRequest,
	FCReconfigWorkflow,
	FCReconfigNodeDetails,
	SorterSetupWorkflowExecution,
	SorterSetupWorkflowRequirementPortal,
	NodeAddressUpdateWorkflow,
	AddressUpdateWorkflowNodeDetails,
	CreateAnchorPointNodes,
	DeleteAnchorPointNodes,
	AppConfigReviewDashboard,
	ListAppConfigReviews,
	ViewAppConfigReview,
	ViewHostedAppConfig,
	OnBoardServiceAppConfig,
	ViewFCToPodMappings,
	AlertNodesDashboard,
	TaskConfiguration,
	NodeNameValidator,
	NotificationManagerNavigation,
	ViewNotifications,
	ManageExecution,
	StartExecution,
	WorkflowDashboard,
	SimulateWorkflow,
	WorkflowCompare,
} from 'src/config/Lazy';

interface AppRoutesProps {
	commonProps: any;
	location: any;
}

export default function AppRoutes({ commonProps, location }: AppRoutesProps) {
	return (
		<ErrorBoundary location={location}>
			<NavigationMetrics />
			<Switch>
				<Route
					exact
					path={ROUTES.ROOT}
					render={() => <Redirect to={ROUTES.HOME} />}
				/>
				<Route
					path={ROUTES.HOME}
					render={(props) => (
						<SNOWHome {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.DASHBOARD}
					render={(props) => (
						<Dashboard {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.FIND_ENTITY}
					render={(props) => (
						<FindEntity {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.FIND_CYCLE}
					render={(props) => (
						<FindCycle {...props} {...commonProps} />
					)}
				/>
				{/*An Example for using the CreateEntityBaseComponent*/}
				<Route
					path={ROUTES.PRE_LAUNCH_WORKFLOW}
					render={(props) => <PreLaunchWorkflow {...props} />}
				/>
				{/*Component for P2R workflow*/}
				<Route
					path={ROUTES.LAUNCH_P2R_WORKFLOW}
					render={(props) => (
						<CreateP2RRequest {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.LAUNCH_RAD_WORKFLOW}
					render={(props: any) => (
						<RADInitialPage
							key={props.match.params.alias}
							{...props}
							{...commonProps}
						/>
					)}
				/>
				<Route
					path={ROUTES.LAUNCH_NEW_STACK}
					render={(props: any) => (
						<ReselienceInitialPage
							key={props.match.params.alias}
							{...props}
							{...commonProps}
						/>
					)}
				/>
				{/*Component for Dockmaster workflow*/}
				<Route
					path={ROUTES.LAUNCH_DOCKMASTER_WORKFLOW}
					render={(props) => (
						<DockmasterRequest {...props} {...commonProps} />
					)}
				/>
				{/*Component for Sorter Setup Workflow*/}
				<Route
					path={ROUTES.LAUNCH_SORTER_WORKFLOW_EXECUTE}
					render={(props) => (
						<SorterSetupWorkflowExecution
							{...props}
							{...commonProps}
						/>
					)}
				/>
				<Route
					path={ROUTES.LAUNCH_SORTER_WORKFLOW}
					render={(props) => (
						<SorterSetupWorkflowRequirementPortal
							{...props}
							{...commonProps}
						/>
					)}
				/>
				<Route
					path={ROUTES.LAUNCH_FC_RECONFIG}
					render={(props: any) => (
						<FCReconfigWorkflow
							key={props.match.params.alias}
							{...props}
							{...commonProps}
						/>
					)}
				/>
				<Route
					path={ROUTES.LAUNCH_FC_RECONFIG_NODE_DETAILS}
					render={(props) => (
						<FCReconfigNodeDetails {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.NODE_NAME_VALIDATOR}
					render={(props) => (
						<NodeNameValidator {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.TASK_DASHBOARD}
					render={(props) => (
						<TaskDashboard {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.LAUNCH_NODE_ADDRESS_UPDATE_WORKFLOW}
					render={(props) => (
						<NodeAddressUpdateWorkflow
							{...props}
							{...commonProps}
						/>
					)}
				/>
				<Route
					path={ROUTES.LAUNCH_NODE_ADDRESS_UPDATE_WORKFLOW_DETAILS}
					render={(props) => (
						<AddressUpdateWorkflowNodeDetails
							{...props}
							{...commonProps}
						/>
					)}
				/>
				<Route
					exact
					path={ROUTES.APP_CONFIG_REVIEW_DASHBOARD}
					render={(props) => (
						<AppConfigReviewDashboard {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.LIST_REVIEWS}
					render={(props) => (
						<ListAppConfigReviews {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.TASK_ONBOARDING}
					render={(props) => (
						<TaskOnboarding {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.WORKFLOW_CREATION_CANVAS}
					render={(props) => (
						<DndFlow {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.REQUIREMENTS_PAGE}
					render={(props) => (
						<SelfServeWorkflowDetails {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.VIEW_REVIEW}
					render={(props) => (
						<ViewAppConfigReview {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.VIEW_HOSTED_CONFIG}
					render={(props) => (
						<ViewHostedAppConfig {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.ONBOARD_SERVICE}
					render={(props) => (
						<OnBoardServiceAppConfig {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.FC_TO_POD_MAPPINGS_DASHBOARD}
					render={(props) => (
						<ViewFCToPodMappings {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.ALERT_NODES_DASHBOARD}
					render={(props) => (
						<AlertNodesDashboard {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.LAUNCH_ANCHOR_POINT_WORKFLOW}
					render={(props) => (
						<CreateAnchorPointNodes {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.DELETE_ANCHOR_POINT_WORKFLOW}
					render={(props) => (
						<DeleteAnchorPointNodes {...props} {...commonProps} />
					)}
				/>
				{/*To DO: remove after merging to the original create workflow Page*/}
				<Route
					path={ROUTES.TEST_WF}
					render={(props) => (
						<UpdateWFDefinitionStep {...props} {...commonProps} />
					)}
				/>
				{/*Component for Contact Page*/}
				<Route
					path={ROUTES.CONTACT}
					render={(props) => (
						<Contact {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.CHANGES}
					render={(props) => (
						<WhatsNewPage {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.ENTITY_SEARCH}
					render={(props) => (
						<EntitySearch {...props} {...commonProps} />
					)}
				/>
				<Route
					exact
					path={ROUTES.MANAGE_WORKFLOWS}
					render={(props) => (
						<ManageWorkflowData {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.WORKFLOW_DASHBOARD}
					render={(props) => (
						<WorkflowDashboard {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.SIMULATE_WORKFLOW}
					render={(props) => (
						<SimulateWorkflow {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.COMPARE_WORKFLOWS}
					render={(props) => (
						<WorkflowCompare {...props} {...commonProps} />
					)}
				/>
				<Route
					exact
					path={ROUTES.EXECUTE_WORKFLOWS}
					render={(props) => (
						<ExecuteWorkflowTable {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.CREATE_WORKFLOW}
					render={(props) => (
						<CreateSelfServeWorkflow {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.VIEW_WORKFLOW}
					render={(props) => (
						<ViewWorkflow {...props} {...commonProps} />
					)}
				/>
				<Route
					exact
					path={ROUTES.REQUIREMENT_PAGE}
					render={(props) => (
						<RequirementsPage {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.LAYOUT_EDITOR}
					render={(props) => (
						<LayoutEditorPage {...props} {...commonProps} />
					)}/>
				<Route
					exact
					path={ROUTES.BULK_EXECUTION}
					render={(props) => {
						const {workflowType} = props.match.params;

						return (
							<BulkExecutionRequirementPortal
								key={workflowType}
								{...props}
								{...commonProps}
							/>
						);
					}}
				/>
				<Route
					path={ROUTES.APPLICATION_MANAGEMENT}
					component={() => <ApplicationOperationNavigation />}
				/>
				<Route
					path={ROUTES.ATTRIBUTE_MANAGEMENT}
					component={() => <AttributeManagementNavigation />}
				/>
				<Route
					path={ROUTES.SUPPORTED_TASK_TYPES}
					render={(props) => (
						<SupportedTaskTypes {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.SUB_TASK_CONFIGURATION}
					render={(props) => (
						<TaskConfiguration {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.CHAT_BOT}
					render={(props) => (
						<FullPageChat {...props} />
					)}
				/>
				<Route
					path={ROUTES.MANAGE_EXECUTION}
					render={(props) => (
						<ManageExecution {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.START_EXECUTION}
					render={(props) => (
						<StartExecution {...props} {...commonProps} />
					)}
				/>
				<Route
					path={ROUTES.VIEW_NOTIFICATIONS}
					component={ViewNotifications}
				/>
				<Route
					path={ROUTES.NOTIFICATION_MANAGER}
					component={NotificationManagerNavigation}
				/>
				<Route component={NotFound} />
			</Switch>
		</ErrorBoundary>
	);
}
